import { render, staticRenderFns } from "./ModalRemoveAccount.vue?vue&type=template&id=0cb451ea&scoped=true&"
import script from "./ModalRemoveAccount.vue?vue&type=script&lang=js&"
export * from "./ModalRemoveAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb451ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cb451ea')) {
      api.createRecord('0cb451ea', component.options)
    } else {
      api.reload('0cb451ea', component.options)
    }
    module.hot.accept("./ModalRemoveAccount.vue?vue&type=template&id=0cb451ea&scoped=true&", function () {
      api.rerender('0cb451ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/myaccount/accountsettings/ModalRemoveAccount.vue"
export default component.exports